module.exports = __webpack_public_path__ + "img/like-act.7861e7d5.png";